var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    {
      tag: "component",
      class: _vm.classes,
      attrs: {
        "active-class": "-active",
        "exact-active-class": "-active",
        to: !_vm.isExternal ? _vm.item.path : null,
        href: _vm.item.path,
        target: _vm.isExternal ? "_blank" : null,
        disabled: _vm.item.disabled
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      },
      nativeOn: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.item.icon
        ? _c("c-icon", {
            staticClass: "icon",
            attrs: { icon: _vm.item.icon, width: "17", height: "17" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.item.name))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02036218", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02036218","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CMenuItem.vue
// module id = Pdjm
// module chunks = 1624